module.exports = __webpack_public_path__ + "static/fonts/Gilroy-Light.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font-gilroy/Gilroy-Light.woff
// module id = K3WM
// module chunks = 0